"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var app_config_store_1 = require("../reverb-js-common/app_config_store");
var DEFAULT_ADYEN_LOCALE = 'en_US';
var REVERB_LANGUAGE_TO_ADYEN_LOCALE = {
    en: 'en_US',
    fr: 'fr_FR',
    ja: 'ja_JP',
    de: 'de_DE',
    it: 'it_IT',
    nl: 'nl_NL',
    zh: 'zh_CN',
    da: 'da_DK',
    no: 'no_NO',
    pl: 'pl_PL',
    pt: 'pt_BR',
    es: 'es_ES',
    sv: 'sv_SE',
};
function mapReverbLocaleToAdyenCheckoutLocale(reverbLocale) {
    var language = reverbLocale.substring(0, 2);
    return REVERB_LANGUAGE_TO_ADYEN_LOCALE[language] || DEFAULT_ADYEN_LOCALE;
}
function buildAdyenCheckoutConfiguration(locale) {
    var adyenCheckoutConfig = app_config_store_1.default.getState().adyenCheckoutConfig;
    return tslib_1.__assign(tslib_1.__assign({}, adyenCheckoutConfig), { locale: mapReverbLocaleToAdyenCheckoutLocale(locale) });
}
function mountComponent(args) {
    var config = buildAdyenCheckoutConfiguration(args.locale);
    var checkout = new window.AdyenCheckout(config);
    var component = checkout.create(args.type, args.props);
    component.mount(args.domSelector);
}
exports.mountComponent = mountComponent;
//# sourceMappingURL=adyen_checkout_mounter.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/adyen_checkout_mounter.js
// module id = ot7s
// module chunks = 20 21 22